module.exports = [{"type":"title","text":"2023-10-12"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual future/spot: The same order is limited to 1 second and can be revoked at most once"},{"type":"html","text":"Spot: New Order Type: TAKE_ STOP_ Limit: TAKE_ STOP_ MARKET: Market price stop loss order TRIGGER_ LIMITED: TRIGGER commissioned for price limit plan_ Market: Market price plan commission"},{"type":"html","text":"Spot: Historical orders returned with additional fee fields"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2023-10-12.json
// module id = 7wfK
// module chunks = 3